import { LayoutTranslation } from 'locales/de/layout';

const en: LayoutTranslation = {
  alerts: {
    servicesDownTitle: 'Services Down',
    servicesDown: 'Some services are currently not available. The user experience might be limited.'
  },
  categories: {
    ARTICLE: 'Article',
    BULLETIN: 'Bulletin Board',
    EVENT: 'Evet',
    FUNDING: 'Funding',
    JOB_OFFER: 'Job Offering',
    STUDENT_OFFER: 'Student Job Application',
    MODULE_SELECTION: 'Selection',
    COMPANY: 'Company'
  },
  menu: {
    dashboard: 'Dashboard',
    watchlist: 'Watchlist',
    titleAWPM: 'AWPM selection',
    titleFWPM: 'FWPM selection',
    jobmarket: 'Job Market',
    internationalOffice: 'International Office',
    jobs: 'Job Offers',
    myJobApplications: 'My job applications',
    studentApplications: 'Stud. job applications',
    manageCompanies: 'Manage Companies',
    manageJobs: 'Manage Jobs',
    manageMyJobs: 'My Job Offers',
    myCompany: 'My Company',
    myInvoices: 'My Invoices',
    settings: 'Settings',
    settingsJobmarket: 'Jobmarket Settings',
    settingsArticles: 'Permissions Settings',
    settingsMessaging: 'Reminder Settings',
    settingsInternationalOffice: 'International Office Settings',
    articles: 'Articles',
    billing: 'Invoice data',
    billingApprove: 'Billing approval',
    billingExport: 'Billing export',
    calendar: 'Calendar',
    polyas: 'Polyas',
    gki: 'gKI-Service',
    chat: 'Chat',
    gKIchat: 'gKI-Chat',
    apiKeys: 'API Keys',
    community: 'Community',
    bulletinBoard: 'Bulletin Board',
    links: 'Links',
    manageInvoices: 'Manage invoices',
    profile: 'Profile',
    leihbar: 'leihBar',
    leihbarHome: 'Catalog',
    leihbarProfile: 'Lender-Profile',
    leihbarDaily: 'Daily Dashboard',
    leihbarStatistics: 'Statistics',
    leihbarAccess: 'Bereichszuordnung',
    shibUserManagement: 'Shibboleth User',
    testUserManagement: 'Test Nutzer',
    settingsSystemNotifications: 'System Notifications Settings',
    moduleSelections: 'Selection overview',
    modules: 'Module catalog',
    groupings: 'Groupings',
    temporarilyDisabled: 'This feature is temporarily disabled and will return shortly.',
    events: 'Events',
    eventsSettings: 'Event settings',
    dashboardCardSettings: 'Tilesettings',
    accessHandler: 'Access Control',
    activityLog: 'Activity Log',
    pricingtable: 'Pricing',
    other: 'Other'
  },
  desktopOnly:
    'This page is not optimized for mobile. To see it please open it on a desktop browser.',
  profile: {
    markAsRead: 'Mark as read',
    markAllAsRead: 'Mark all as read',
    view: 'View'
  }
};
export default en;
